var Tabs = function() {

	this.init = function() {

		this.tabs();

	}

	this.tabs = function() {

		$('.tab-list li').on('click', function(){

			$('.tab-list li').removeClass('current');
			$(this).addClass('current');
		});

	}

	return this.init();

}
